export default __webpack_public_path__ + "static/media/icon-chevron-down-small.446c70cf.svg";